import React from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const TeacherOldQuestion = ({question, teachername}) => {

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div>
        <div className="timeline-block ">
            <span className="timeline-step badge-white bg-gradient-primary">
              <i className="fa fa-question"></i>
            </span>
            <div className="timeline-content qCenter2 qFirstT">            
              <h6 className="  tittleColor33 ">
                <span className='tittleColor oldQt ' style={{textTransform: 'capitalize'}}>
                  <span className='studenT3  '>
                {question[0].tittle}
                  </span>
                </span>
                </h6>  
                <LinkContainer to={`/teacherwatchquestion/${question[0]._id}`} className='btn  '>
                <div className="icon-image-wrapper">
                <video 
                    src={`https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/questions/${question[0]?.mediaId}`}
                    className='questImg4'
                  />
                  <i class="fa fa-play play-icon" ></i>
                </div>
                </LinkContainer>
              <h6 className=" mt-2 mb-0 qAnsw">
              <span className='studenT2'>
              {question[0].description}
              </span>
              </h6>
              <p className=" text-sm mt-0 mb-0 createdBy" >
              by <span style={{ textTransform: 'capitalize' }}> {question[0].studentname}  </span>
              at {formatDate(question[0].createdAt)}
              </p>
              <div className="mt-2">
                <LinkContainer to={`/teacherwatchquestion/${question[0]._id}`} className='btn btn-default questbtn'>
                  <Button variant="info  bg-gradient-primary border border-0 rounded-pill questResp2"> Watch Question </Button>
                </LinkContainer>    
              </div>
            </div>                           
        </div>    
        <div className="timeline-block">
            <span className="timeline-step badge-white bg-gradient-warning ">
              <i className="ni ni-check-bold"></i>
            </span>
            <div className="timeline-content">
              {/* <h6 className="text-muted font-weight-bold">                            
                <span className='tittleColor22  questionFont'>Answer</span>
              </h6> */}
              <LinkContainer to={`/teacherwatchanswer/${question[1]._id}`} className='btn '>
              <div className="icon-image-wrapper">
              <video 
                  src={`https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/asnwers/${question[1]?.mediaId}`}
                  className='questImg5'
                  />
                <i class="fa fa-play play-icon" ></i>
              </div>
              </LinkContainer>  
              <h6 className=" mt-3 mb-0 qAnsw">
              <span className='studenT2'>
              {question[1].description}
              </span>
              </h6>
              <p className=" text-sm mt-0 mb-0 createdBy">
              by <span style={{ textTransform: 'capitalize' }}> {teachername} </span>
              at  {formatDate(question[1].createdAt)}
              </p>
              <div className="mt-2">
                {question[1].mediaId != 'none' ? (
                <LinkContainer to={`/teacherwatchanswer/${question[1]._id}`} className='btn btn-default bg-gradient-warning '>
                  <Button variant="primary  border border-0 rounded-pill questbtn questResp2">&nbsp; Watch  Answer &nbsp; </Button>
                </LinkContainer> ) : (
              <LinkContainer to={`/teacheranswertype/${question[1]._id}`} className='btn btn-default'>
              <Button variant="primary offset-xl-2 bg-gradient-warning border border-0 rounded-pill"> Add Video </Button>
            </LinkContainer>  
            )}
              </div>
            </div>   
        </div>        
    </div>
  )
}

export default TeacherOldQuestion
